const assets = {
    images: {
        configuratorHero: require('./images/madjax-cart-configurator-hero.jpg'),
        madjaxVehiclesLogoWhite: require('./images/mj-vehicles-logo-white.png'),
        madjaxXSeriesLogoWhite: require('./images/mj-xseries-logo-white.png'),
        madjaxESeriesLogoWhite: require('./images/mj-xseries-logo-white.png'),
        missingImage: require("./images/missing_image.png"),
        logo: require('./images/madjax-logo.png'),
        logoWhite: require('./images/madjax-logo-white.png'),
        logoMadJaxVillages: require('./images/madjax-the-villages-logo.png'),
        logoMadJaxVillagesWhite: require('./images/madjax-the-villages-logo-white.png'),
        logoMadJaxVillagesWarrantyRegistration: require('./images/madjax-the-villages-logo-warranty-registration.png'),
        emptyImage: require('./images/empy_image.png'),
        overheadFreightTruck: require('./images/overhead-freight-truck.png'),
        backgroundImage: require('./images/logos/ascent-logo-large.png'),
        chassisBadges: {
            x2: require('./images/badges/x2-icon.png'),
            x4: require('./images/badges/x4-icon.png'),
            x6: require('./images/badges/x6-icon.png'),
            e4: require('./images/badges/e4-icon.png'),
            ascent: require('./images/badges/ascent-badge.png'),
            x4Gen3: require('./images/badges/xseries-gen3-badge.png')
        },
        seatSwatches: {
            ranch: require('./images/seat-swatches/seat-ranch-swatch.jpg'),
            ltGraphite: require('./images/seat-swatches/seat-lt-graphite-swatch.jpg'),
            gunmetalGray: require('./images/seat-swatches/seat-gunmetal-gray-swatch.jpg'),
            admiralBlue: require('./images/seat-swatches/seat-admiral-blue-swatch.jpg'),
            cherryRed: require('./images/seat-swatches/seat-cherry-red-swatch.jpg'),
            rossoRed: require('./images/seat-swatches/seat-rosso-red-swatch.jpg'),
            frostWhite: require('./images/seat-swatches/seat-frost-white-swatch.jpg'),
            limeGreen: require('./images/seat-swatches/seat-lime-green-swatch.jpg'),
            neonYellow: require('./images/seat-swatches/seat-neon-yellow-swatch.jpg'),
            amethystPurple: require('./images/seat-swatches/seat-amethyst-purple-swatch.jpg'),
            vividOrange: require('./images/seat-swatches/seat-vivid-orange-swatch.jpg'),
            boltBlue: require('./images/seat-swatches/seat-bolt-blue-swatch.jpg'),
            seaStorm: require('./images/seat-swatches/seat-sea-storm-swatch.jpg'),
            onyx: require('./images/seat-swatches/seats-onyx-swatch.jpg'),
            caribbeanHoliday: require('./images/seat-swatches/seats-caribbean-holiday-swatch.jpg'),
            leafGreen: require('./images/seat-swatches/seats-leaf-green-swatch.jpg'),
            ocean: require('./images/seat-swatches/seats-ocean-swatch.jpg'),
            chiliPepper: require('./images/seat-swatches/seats-chili-pepper-swatch.jpg')
        },
        legendAssignedDealerPin: require('./images/legend-assigned-dealer-pin.png'),
        legendDealerPin: require('./images/legend-dealer-pin.png'),
        legendProspectPin: require('./images/legend-prospect-pin.png'),
        legendDealerPriorityPin: require('./images/legend-dealer-priority.png')
    }
}

export default assets;